import React from 'react';
import { Button, Box } from '@material-ui/core';
import { TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

import Modal, { ModalContents, ModalTitle, ModalTypography } from 'components/Modal/Modal';

export const RejectAddressChangeModal = ({
  onClose,
  onReject,
}: {
  onClose: () => void;
  onReject: (data: { rejectionReason: string }) => void;
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm<{ rejectionReason: string }>({
    defaultValues: {
      rejectionReason: '',
    },
    mode: 'onChange',
  });

  return (
    <Modal style={{ zIndex: 1200 }} open fullWidth onClose={onClose}>
      <ModalContents
        onClickClose={onClose}
        body={
          <Box mb={4}>
            <ModalTitle>Reject Address Change Request</ModalTitle>
            <ModalTypography>
              Are you sure you want to reject this address change request? This will close the
              ticket and notify the requester with the rejection reason.
            </ModalTypography>
            <Controller
              name="rejectionReason"
              control={control}
              rules={{
                required: 'Please enter a reason for the address change rejection',
                maxLength: 300,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Rejection Reason"
                  helperText="Why is this address change request being rejected?"
                  fullWidth
                  required
                  variant="standard"
                  error={Boolean(errors.rejectionReason)}
                />
              )}
            />
          </Box>
        }
        actions={
          <Button
            color="primary"
            type="button"
            variant="contained"
            style={{ marginRight: 8 }}
            onClick={handleSubmit(onReject)}
            disabled={!isValid}
          >
            Reject the address change request
          </Button>
        }
      />
    </Modal>
  );
};
